import { useCompanyMaintenanceTracked } from "presentation/store/Company/CompanyMaintenanceProvider";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useMemo } from "react";
import ChargeSuppleTermsTablePanel from "./ChargeSuppleTermsTablePanel";
import CompanyEmptyPoolTablePanel from "./CompanyEmptyPoolTablePanel";
import CompanyFspTablePanel from "./CompanyFspTablePanel";
import CompanyTeuFactorTablePanel from "./CompanyTeuFactorTablePanel";
import CustomerAssignmentTablePanel from "./CustomerAssignmentTablePanel";


const CompanyDetailTablePanel: React.FC = () => {
    const [companyState] = useCompanyMaintenanceTracked();
    const { isShowMaster, isShowAlliance } = companyState

    const memoCompanyFspTable = useMemo(() => {
        return <div style={{ marginLeft: "15px" }}><CompanyFspTablePanel /></div>
    }, [])

    const memoChargeSuppleTermsTable = useMemo(() => {
        return <div style={{ marginLeft: "15px" }}><ChargeSuppleTermsTablePanel /></div>
    }, [])

    const memoCompanyEmptyPoolTable = useMemo(() => {
        return <div style={{ marginLeft: "15px" }}><CompanyEmptyPoolTablePanel /></div>
    }, [])

    const memoCompanyTeuFactorTable = useMemo(() => {
        return <div style={{ marginLeft: "15px" }}><CompanyTeuFactorTablePanel /></div>
    }, [])

    const memoCustomerAssignMentTable = useMemo(() => {
        return <div style={{ marginLeft: "15px" }}><CustomerAssignmentTablePanel /></div>
    }, [])

    // const memoCompanyDockageMentTable = useMemo(() => {
    //     return <div style={{ marginLeft: "15px" }}><CompanyDockageTablePanel /></div>
    // }, [])

    return <><div className="main-comp-wrapper">
        <div style={{ width: '100%', height: '100%', maxHeight: '95%', overflow: 'auto' }}>
            <TableWrapper> {!isShowMaster && !isShowAlliance && memoCompanyFspTable} </TableWrapper>
            <TableWrapper> {memoCompanyEmptyPoolTable} </TableWrapper>
            <TableWrapper> {!isShowMaster && !isShowAlliance && memoChargeSuppleTermsTable} </TableWrapper>
            <TableWrapper> {!isShowMaster && !isShowAlliance && memoCustomerAssignMentTable} </TableWrapper>
            <TableWrapper> {!isShowMaster && !isShowAlliance && memoCompanyTeuFactorTable} </TableWrapper>
            {/*<TableWrapper> {!isShowMaster && !isShowAlliance && (operatingUnit === "AQCT" || operatingUnit === "RSCT") && memoCompanyDockageMentTable} </TableWrapper>*/}
        </div>
    </div></>;
}

export default memo(CompanyDetailTablePanel);
